import React, { useState, useEffect } from 'react'
import { footerLinks as defaultLinks } from '../constants'
import api from '@/lib/api';

const Footer = () => {
  const [content, setContent] = useState({
    copyright: 'Copyright @ 2024 SNC AI Training. All rights reserved.',
    links: defaultLinks
  });

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const { data } = await api.get('/sections/Footer');
        if (data && data.content) {
          const contentMap = {};
          data.content.forEach(item => contentMap[item.key] = item.value);

          if (contentMap.copyrightText) setContent(prev => ({ ...prev, copyright: contentMap.copyrightText }));
          // FooterEditor handles generic links via policies, we could map them here or stick to constants if the structure differs
        }
      } catch (error) {
        console.error("Failed to fetch Footer content", error);
      }
    };
    fetchContent();
  }, []);

  return (
    <footer className="py-5 sm:px-10 px-5 bg-slate-50 dark:bg-black transition-colors duration-300">
      <div className="screen-max-width">
        <div>
          <p className="font-semibold text-gray text-xs">
            Experience Excellence: {' '}
            <span className="underline text-blue cursor-pointer">
              Explore Our Tools {' '}
            </span>
            or {' '}
            <span className="underline text-blue cursor-pointer">
              Get Started
            </span>{' '}
            today.
          </p>
        </div>

        <div className="bg-black/10 dark:bg-neutral-700 my-5 h-[1px] w-full" />

        <div className="flex md:flex-row flex-col md:items-center justify-between">
          <p className="font-semibold text-gray text-xs">{content.copyright}</p>
          <div className="flex">
            {content.links.map((link, i) => (
              <p key={link} className="font-semibold text-gray text-xs">
                {link}{' '}
                {i !== content.links.length - 1 && (
                  <span className="mx-2"> | </span>
                )}
              </p>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer